"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNavigation = void 0;
var _react = require("react");
var _reactRouter = require("react-router");
var _useMultiSite = require("./use-multi-site");
var _utils = require("../../utils");
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * A convenience hook for programmatic navigation uses history's `push` or `replace`. The proper locale
 * is automatically prepended to the provided path. Additional args are passed through to `history`.
 * @returns {function} - Returns a navigate function that passes args to history methods.
 */
const useNavigation = () => {
  const history = (0, _reactRouter.useHistory)();
  const {
    site,
    locale,
    buildUrl
  } = (0, _useMultiSite.useMultiSite)();
  return (0, _react.useCallback)(
  /**
   *
   * @param {string} path - path to navigate to
   * @param {('push'|'replace')} action - which history method to use
   * @param  {...any} args - additional args passed to `.push` or `.replace`
   */
  (path, action = 'push', ...args) => {
    const regexSiteAlias = new RegExp(`^/((${site.alias || site.id})/)?(([a-z]{2})(-[A-Z]{2})?)/.*`);
    const replaceSiteAlias = new RegExp(`^/((${site.alias || site.id})/)?(([a-z]{2})(-[A-Z]{2})?)`);
    const hasSiteAliasAndOrLocale = regexSiteAlias.test(path);
    const newPath = hasSiteAliasAndOrLocale ? path.replace(replaceSiteAlias, '') : path;
    if ((0, _utils.isExternalUrl)(path) && typeof window !== 'undefined') {
      window.location.href = path;
    } else {
      // @ts-ignore
      const updatedHref = buildUrl(newPath);
      // @ts-ignore
      history[action](newPath === '/' ? '/' : updatedHref, ...args);
    }
  }, [locale === null || locale === void 0 ? void 0 : locale.id, site]);
};
exports.useNavigation = useNavigation;